module.exports = __webpack_public_path__ + "img/editar.ee4bf83d.svg";